import { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const DeleteFileButton = ({ f, onDelete }) => {
  const [busy, setBusy] = useState(false);
  const name = f.package_name || f.original_filename;
  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onDelete(f.id, name);
    setBusy(false);
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button title="Delete file" className="rounded-full p-2 text-slate-500 transition-colors hover:bg-red-50 hover:text-red-700" data-testid={`apps-file-delete-${f.id}`}>
          <Trash2 className="h-4 w-4" />
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="rounded-3xl" data-testid={`apps-file-delete-dialog-${f.id}`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">Delete this file?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm text-slate-600">
              <p className="break-all font-mono text-xs text-ink">{name}{f.version ? ` · v${f.version}` : ""}</p>
              {f.package_name && <p className="break-all font-mono text-[11px] text-slate-500">{f.original_filename}</p>}
              <p>It will be removed from the list for everyone, and existing download links will stop working. This can't be undone from this page.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} className="rounded-full" data-testid={`apps-file-delete-cancel-${f.id}`}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={run} disabled={busy} className="rounded-full bg-red-600 hover:bg-red-700" data-testid={`apps-file-delete-confirm-${f.id}`}>
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Delete file
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
